// import BlankLayout from "@/layouts/blank";
import MasterLayout from "@/layouts/master";
import NotFound from "@/views/not-found";
import authRoutes from "./authRoutes.js";
import pdfRoutes from "./pdfRoutes.js";
import pacienteRoutes from "./pacienteRoutes.js";
import basicoRoutes from "./basicoRoutes.js";
import ordenRoutes from "./ordenRoutes.js";
import proveedorRoutes from "./proveedorRoutes.js";
import adminRoutes from "./adminRoutes.js";

const baseRoutes = [
  {
    path: "/admin",
    component: MasterLayout,
    children: [
      {
        path: "/home",
        name: "admin.home",
        component: () => import("@/views/home.vue")
      }
    ]
  },
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "*",
    name: "notFound",
    component: NotFound
  }
]

const importedRoutes = [  
  basicoRoutes, 
  ordenRoutes,
  proveedorRoutes,
  pacienteRoutes,
  adminRoutes,
  authRoutes,
  pdfRoutes
];

const routes = importedRoutes.reduce(function(prev,moduleRoute){
  return prev.concat(moduleRoute);
},baseRoutes)


export default routes;